import React from 'react';
import { Outlet, useLocation } from "react-router-dom";
import './Layout.scss';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { ThemeProvider } from '@mui/material/styles';
import { Box, Toolbar, } from '@mui/material';
import Header from "../Header/Header";
import { getAppTheme } from '../../services/authContext';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import Chatbot from '../Chatbot/Chatbot';
import Footer from '../Footer/Footer';

const MainContent = () => {
  const mode = useSelector((state) => state.theme.mode) // Use directly
  const location = useLocation(); // Get current location from react-router-dom
  const theme = getAppTheme(mode);
  useEffect(() => {
    console.log(mode);
  }, [mode]);

  const handleFixedDeposit = () =>{
    window.location.href= "https://makeloaneasy-uat0.tarrakki.com/"
  }
  
  const isNewsPage = location.pathname === '/news';

  return (
    <ThemeProvider theme={theme}>
      <Box className="fixedAppBar" sx={{ flex: 1, background: theme.palette.background.default, color: theme.palette.color.default}}>
        {/* <Box> */}
          <Header handleFixedDeposit={handleFixedDeposit} />
          {!isNewsPage && (
            <Toolbar sx={{maxHeight:"56.8px !important", minHeight:"56.8px !important"}} />
          )}
          <Box sx={{minHeight:"calc(100vh-56.8px) !important"}}>

          <Outlet />
          </Box>
          {!isNewsPage && (
            <Footer/>
          )}
        {/* </Box> */}
      </Box>
    </ThemeProvider>
  );
};

const Layout = () => {
  const mode = useSelector((state) => state.theme.mode)
  const theme = getAppTheme(mode);

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ minHeight: "100vh", width: "100%" }}>
        {/* {loginStatus.token && !isMobile ?
          <Sidebar />
          :
          null
        } */}

        <MainContent />
        <Chatbot />
      </Box>
    </ThemeProvider >
  );
};

export default Layout;
